// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__10d06","label":"Labeled_label__e32jO","divider":"Labeled_divider__2xkZ2"};